import colors from '@rategravity/frontend/theme/colors';
import React from 'react';
import Checkbox from '../../components/Checkbox';
import { LinkOutIcon } from '../../shared/icons';

const style = {
  link: {
    color: colors.tertiary
  }
};

/**
 * @param {boolean} coborrowerStatus
 */
const Label = (coborrowerStatus) => (
  <label htmlFor="authorizationCheckbox">
    {coborrowerStatus ? 'We ' : 'I '}
    authorize Own Up to verify {coborrowerStatus ? 'our ' : 'my '}
    credit using a soft credit check that will not impact{' '}
    {coborrowerStatus ? 'our scores. We ' : 'my score. I'} have also read and agreed to Own
    Up&apos;s{' '}
    <span style={style.link}>
      <a
        href="https://www.ownup.com/terms-conditions"
        className="link__hover--yellow"
        target="_blank"
        rel="noreferrer"
      >
        Terms of Use <LinkOutIcon />
      </a>
    </span>{' '}
    and{' '}
    <span style={style.link}>
      <a
        href="https://www.ownup.com/privacy"
        className="link__hover--yellow"
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy <LinkOutIcon />
      </a>
    </span>
    .
  </label>
);

/**
 * Renders the Authorization component for the Credit Authorization card.
 * @param model A representation of the state (see: stateContainer). It is an
 *   Immutable Map with the following keys: borrower, loan, coborrower.
 * @param onChange Function with the following parameters:
 *   @param modelKey Root-level key on the ImmutableJS model
 *            (i.e., "borrower", "loan", "coborrower").
 *   @param key Key on the second level (e.g. "creditAgree" on loan).
 *   @param val The new value for the key.
 */
export const Authorization = ({ model, onChange }) => (
  <Checkbox
    id="authorizationCheckbox"
    style={{ marginLeft: '-3px', width: 'auto' }}
    value={model.getIn(['loan', 'creditAgree'])}
    /**
     * The labelStyle fix is necessary because the version of
     * MaterialUI that we are using has a bug that prevents
     * elements from having their own events if they are inside
     * the label of a Checkbox component.
     */
    labelStyle={{ zIndex: 3 }}
    label={Label(model.getIn(['loan', 'hasCoborrower']))}
    onChange={onChange.bind(null, 'loan', 'creditAgree')}
  />
);



// WEBPACK FOOTER //
// ./src/cards/credit-authorization/authorization.js